import { render, staticRenderFns } from "./InputTipoDadoErros.vue?vue&type=template&id=6460bf37&"
import script from "./InputTipoDadoErros.vue?vue&type=script&lang=js&"
export * from "./InputTipoDadoErros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports